// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title-font{font-family:Sora,Manrope,Segoe UI,Arial,sans-serif}", "",{"version":3,"sources":["webpack://./resources/js/src/App.css"],"names":[],"mappings":"AAAA,YACE,kDACF","sourcesContent":[".title-font {\n  font-family: 'Sora', 'Manrope', 'Segoe UI', Arial, sans-serif;\n}\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
